export default function AboutHero() {
  return (
    <section className="relative min-h-[70vh] flex items-end overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=aerial%20view%20of%20vibrant%20African%20community%20gathering%20in%20an%20open%20field%2C%20colorful%20traditional%20attire%2C%20people%20forming%20a%20circle%2C%20warm%20golden%20hour%20sunlight%2C%20lush%20green%20surroundings%2C%20hopeful%20and%20celebratory%20atmosphere%2C%20documentary%20photography%20style&width=1920&height=1080&seq=about-hero01&orientation=landscape"
          alt="IKIRU community"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#1A0A1E] via-[#2D0A35]/60 to-transparent"></div>
      </div>

      {/* Purple ribbon top */}
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-[#4B0082] via-[#C084FC] to-[#7B2D8B] z-20"></div>

      {/* Floating pill */}
      <div className="absolute top-32 left-1/2 -translate-x-1/2 inline-flex items-center gap-2 px-5 py-2 rounded-full border border-purple-400/30 bg-purple-900/30 backdrop-blur-sm">
        <span className="w-2 h-2 rounded-full bg-[#C084FC] animate-pulse"></span>
        <span className="text-purple-200 text-sm tracking-wide">Our Story & Purpose</span>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 md:px-10 pb-20 pt-40">
        <div className="max-w-4xl">
          <h1 className="text-5xl md:text-7xl font-extrabold text-white leading-tight mb-6">
            We Are <span className="text-[#C084FC]">IKIRU</span>
          </h1>
          <p className="text-white/75 text-xl leading-relaxed max-w-2xl">
            A movement born from compassion, driven by purpose, and committed to giving life, hope, and dignity to every person living with epilepsy across Nigeria and Africa.
          </p>
        </div>

        {/* Stat strip */}
        <div className="mt-14 flex flex-wrap gap-10">
          {[
            { value: 'Nigeria', label: 'Headquartered' },
            { value: 'Pan-African', label: 'Reach & Vision' },
            { value: '2027', label: 'Impact Milestone' },
            { value: '5', label: 'Core Programs' },
          ].map((s) => (
            <div key={s.label}>
              <div className="text-2xl font-extrabold text-[#C084FC]">{s.value}</div>
              <div className="text-white/50 text-xs uppercase tracking-widest mt-1">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
